var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Arrester(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.82 52.67h-.33a6 6 0 00-11 0h-1A6 6 0 0034 50.49v16.76a6.31 6.31 0 01-4.74 6.17 6.39 6.39 0 01-1.45.17 6.21 6.21 0 01-3.66-1.18 2.001 2.001 0 112.35-3.24 2.23 2.23 0 001.85.35A2.28 2.28 0 0030 67.25V50.69a6 6 0 00-9.64 2h-1a6 6 0 00-11 0H8A24.06 24.06 0 0130 31v-2.75a2 2 0 014 0V31a24.07 24.07 0 0121.82 21.67zM68.47 14H52.74L63 2h-5.23L44.05 18h15.52l-6.38 7.19L50 22v10h10l-4-4 12.47-14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Arrester.266249cf.svg";
export { SvgA4Arrester as ReactComponent };